import { ACTION_GET_GATE_CONFIG, ACTION_GET_GATE_CONFIG_ERROR, ACTION_GET_GATE_CONFIG_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getGateConfigReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_GET_GATE_CONFIG:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_GET_GATE_CONFIG_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_GET_GATE_CONFIG_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}